import React from 'react';
import Select from 'react-select';
import { Label, ErrorMessage } from '../FormikCustom';

class ExpirationDate extends React.Component {
    constructor(props, context) {
        super(props, context);
        const me = this;
        const currentYear = new Date().getFullYear();
        me.state = {
            months: me.getMonths(),
            years: me.getYears(currentYear, currentYear + 6),
            selectedYear: null,
            selectedMonth: null,
        };
    }
    initDefaultValues() {
        // debugger;
        this.setState({
            selectedMonth: null, // this.state.months[0].value,
            selectedYear: null, // this.state.years[0].value
        });
    }
    componentDidMount() {
        this.initDefaultValues();
    }
    getMonths() {
        let months = [];
        for (let i = 1; i <= 12; i++) {
            let value = i < 10 ? `0${i}` : i;
            months.push({ value: value, label: value });
        }
        return months;
    }
    getYears(from, to) {
        let years = [];
        for (let i = from; i <= to; i++) {
            years.push({ value: i, label: i });
        }
        return years;
    }
    onYearChange(value) {
        const me = this;
        let year = value.value.toString().substring(2);
        me.setState({ selectedYear: year });
        let expirationDate = me.props.value;

        let month = expirationDate !== null ? expirationDate.substr(0, 2) : me.state.selectedMonth;
        me.setExpirationDate(month, year);
    }
    onMonthChange(value) {
        const me = this;
        let month = value.value;
        me.setState({ selectedMonth: month });
        let expirationDate = me.props.value;

        let _year = me.state.selectedYear ? me.state.selectedYear.toString().substr(2, 2) : null;
        let year = expirationDate !== null ? expirationDate.substr(2, 2) : _year;

        this.setExpirationDate(month, year);
    }
    setExpirationDate(month, year) {
        let expirationDate = `${month ? month : '00'}${year ? year : '00'}`;
        this.handleExpirationDateChange(expirationDate);
    }
    handleExpirationDateChange = (expirationDate) => {
        if (this.props.onChange && typeof this.props.onChange === 'function') {
            this.props.onChange(expirationDate);
        }
    };
    handleOnBlur() {
        this.props.onBlur({ target: { name: this.props.name } });
    }

    render() {
        const me = this;
        const props = me.props;
        const disabled = props.disabled;

        const labelSizeClass = props.labelSize !== undefined ? `col-sm-${props.labelSize}` : 'col-sm-3 col-lg-2';
        const labelStyle = `${labelSizeClass} col-form-label`;

        const valueWidthClass = props.size !== undefined ? `col-sm-${props.size}` : 'col-sm-7';
        const columnStyle = `${valueWidthClass} col-form-control`;
        const columnStyleError = `col-sm-${props.size + 3} col-form-control`;

        const className = props.error && props.touched ? 'react-select error touched' : 'react-select';

        return (
            <div>
                <div className="form-group row">
                    <div className={labelStyle}>
                        <Label htmlFor="CreditCardExpirationDate">Expiration Date:</Label>
                    </div>
                    <div className={columnStyle}>
                        <Select
                            name="Months"
                            isDisabled={disabled}
                            options={me.state.months}
                            onChange={me.onMonthChange.bind(me)}
                            onBlur={me.handleOnBlur.bind(me)}
                            className={className}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            value={
                                props.value
                                    ? {
                                          value:
                                              props.value.substring(0, 2) === '00' ? '' : props.value.substring(0, 2),
                                          label:
                                              props.value.substring(0, 2) === '00' ? '' : props.value.substring(0, 2),
                                      }
                                    : '' // me.state.months[0]
                            }
                        />
                    </div>
                    <div className={columnStyle}>
                        <Select
                            name="Years"
                            isDisabled={disabled}
                            options={me.state.years}
                            onChange={me.onYearChange.bind(me)}
                            onBlur={me.handleOnBlur.bind(me)}
                            className={className}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            value={
                                props.value
                                    ? {
                                          value:
                                              props.value.substring(2, 4) === '00'
                                                  ? ''
                                                  : `20${props.value.substring(2, 4)}`,
                                          label:
                                              props.value.substring(2, 4) === '00'
                                                  ? ''
                                                  : `20${props.value.substring(2, 4)}`,
                                      }
                                    : '' // me.state.years[0]
                            }
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <div className={labelStyle}></div>
                    <div className={columnStyleError}>
                        <ErrorMessage name="ExpiryDate" />
                    </div>
                </div>
            </div>
        );
    }
}
export default ExpirationDate;
